export default function FeatureSection() {
  return (
    <section className="relative w-full bg-background-100 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <p className="text-xs md:text-sm font-medium text-foreground-400 uppercase tracking-[0.2em] mb-4">
            Superbuy Spreadsheet
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight max-w-2xl">
            Your Shopping,
            <br />
            <span className="italic font-normal text-foreground-600">Beautifully Organized</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-foreground-950 rounded-3xl p-8 md:p-10 flex flex-col justify-between min-h-[340px] group cursor-default">
            <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white/10 mb-6">
              <i className="ri-stack-line text-xl text-white" />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">Smart Sorting</h3>
              <p className="text-white/50 text-sm leading-relaxed">
                Automatically categorize products by type, brand, price range, and priority.
                Never lose track of an item again.
              </p>
            </div>
          </div>

          <div className="relative rounded-3xl overflow-hidden min-h-[340px] group cursor-default">
            <img
              src="https://readdy.ai/api/search-image?query=A%20single%20charcoal%20grey%20oversized%20sweatshirt%20draped%20elegantly%20across%20a%20warm%20caramel%20leather%20armchair%20near%20a%20sunlit%20window%20with%20soft%20diffused%20afternoon%20light%20streaming%20through%20sheer%20curtains%20creating%20gentle%20highlights%20on%20the%20fabric%20folds%20and%20subtle%20warm%20shadows%20across%20the%20scene%20cozy%20editorial%20fashion%20photography%20with%20rich%20warm%20earthy%20tones%20and%20inviting%20atmosphere&width=800&height=600&seq=feature-bg-v2&orientation=landscape"
              alt="Superbuy Spreadsheet buying guide"
              title="Superbuy Spreadsheet Buying Guide"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
            <div className="absolute top-6 left-6">
              <span className="inline-flex items-center gap-2 px-4 py-2 bg-black/50 backdrop-blur-sm rounded-full text-white/90 text-xs font-medium">
                <i className="ri-book-open-line" />
                Buying Guide
              </span>
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-2">
                Step-by-Step Guides
              </h3>
              <p className="text-white/70 text-sm">
                From finding the best deals to final checkout
              </p>
            </div>
          </div>

          <div className="rounded-3xl p-8 md:p-10 flex flex-col justify-between min-h-[340px] bg-background-50 border border-background-200 group cursor-default">
            <div>
              <p className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 mb-2">10K+</p>
              <p className="text-lg font-heading italic text-foreground-600 mb-3">Products Tracked</p>
              <p className="text-sm text-foreground-500 leading-relaxed">
                Our spreadsheet system has helped shoppers organize over ten thousand products
                across hundreds of categories.
              </p>
            </div>
            <div className="mt-6 rounded-2xl overflow-hidden h-32">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20top%20down%20arrangement%20of%20mixed%20fashion%20items%20including%20a%20woven%20straw%20hat%20round%20sunglasses%20and%20a%20lightweight%20linen%20scarf%20scattered%20in%20a%20casual%20editorial%20composition%20on%20a%20warm%20grey%20textured%20concrete%20surface%20with%20soft%20nondirectional%20natural%20light%20from%20an%20overcast%20sky%20creating%20gentle%20even%20illumination%20and%20subtle%20texture%20details%20lifestyle%20product%20photography%20with%20relaxed%20refined%20aesthetic&width=800&height=400&seq=feature-stats-v2&orientation=landscape"
                alt="Superbuy Spreadsheet tracked products"
                title="Thousands of products organized with Superbuy Spreadsheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}